import React from "react";

const FeatureTilesSection = ({ heading2, benefits, icon, featp }) => {
  return (
    <section className="bg-light py-8 md:py-12 px-4 md:px-6">
      <div className="container mx-auto text-center">
        {/* Heading */}
        <h2 className="text-2xl md:text-3xl font-bold text-secondary mb-6 md:mb-10">
          {heading2}
        </h2>

        {/* Feature Tiles (Centered Layout) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3 md:gap-4">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white md:rounded-lg shadow-md p-3 md:p-4 flex flex-col items-center text-center transition-transform transform hover:scale-105 hover:shadow-lg"
            >
              {/* Icon and Subhead in Center */}
              <div className="flex items-center justify-center space-x-2">
                <span className="text-yellow-400 text-lg md:text-xl">{icon}</span>
                <strong className="text-primary">{benefit.subhead}</strong>
              </div>

              {/* Content Below */}
              <p className="text-sm md:text-base text-gray-700 mt-2">
                {benefit.content}
              </p>
            </div>
          ))}
        </div>

        {/* Last Paragraph (Equal Spacing Without Increasing Length) */}
        <p className="text-sm md:text-base font-bold text-[#578d48] mt-8 mb-4">
          {featp}
        </p>
      </div>
    </section>
  );
};

export default FeatureTilesSection;
